/** Canonical suggestion chips for the global Ask the Cook entry (nav + mobile sheet). */

export const GLOBAL_ASK_PROMPTS = [
  'What can I make with chicken, lemon & broccoli?',
  'Give me 3 vegetarian dinners under 30 min',
  'Plan my week around what expires soon',
]
